import { render, staticRenderFns } from "./_manageSitesOfClientModal.vue?vue&type=template&id=66ae632b"
import script from "./_manageSitesOfClientModal.vue?vue&type=script&lang=js"
export * from "./_manageSitesOfClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports